import { useTranslation } from '@frontend/i18n';
import { formatPhoneFaxNumber } from '@frontend/phone-numbers';
import type { GetWeavePopNotificationByType, NotificationActions } from '@frontend/types';
import { BaseNotificationComponentProps, BaseNotificationInner, BaseNotificationOuter } from './base';
import { DefaultNotificationBody } from './defaults/default-notification';

type Props = BaseNotificationComponentProps<GetWeavePopNotificationByType<'fax-new'>>;

export const FaxNotificationComponent = ({ isHistorical, emit, notification, ...rest }: Props) => {
  const { t } = useTranslation();
  const actions: NotificationActions = [
    {
      label: t('View'),
      action: () => {
        emit({ action: 'view', payload: undefined }, notification);
      },
    },
  ];

  return (
    <BaseNotificationOuter
      actions={actions}
      notification={notification}
      emit={emit}
      isHistorical={isHistorical}
      {...rest}
    >
      <BaseNotificationInner
        onClose={() => emit({ action: 'ignore', payload: undefined }, notification)}
        actions={actions}
        title={notification.payload.action === 'status' ? t('Fax Send Failed') : t('Fax Received')}
        body={
          <DefaultNotificationBody
            name={formatPhoneFaxNumber(notification.payload.from)}
            body={
              notification.payload.action === 'status'
                ? t('Fax failed to send, please try again')
                : t('New Inbound Fax Received')
            }
          />
        }
        location={notification.location}
        timestamp={notification.timestamp}
        id={notification.id}
        notificationType={notification.type}
        {...rest}
      />
    </BaseNotificationOuter>
  );
};
